import React from 'react';
import { Box, Button, FormControl, FormLabel, Select, Text } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '../auth/ProfileContext';
import { useWorkspaces } from './WorkspaceContext';
import { workspaceForPath } from './api';

export const WorkspaceSwitcher: React.FC = () => {
  const { workspaces, loading, error, reload } = useWorkspaces();
  const { profile } = useProfile();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const inAdmin = pathname.startsWith('/admin') && profile?.isAdmin === true;
  const selected = inAdmin ? 'platform' : workspaceForPath(workspaces, pathname)?.workspaceId || '';
  return (
    <Box>
      <FormControl>
        <FormLabel fontSize="xs" mb={1}>Workspace</FormLabel>
        <Select
          aria-label="Switch workspace" size="sm" borderRadius="md"
          value={selected} isDisabled={loading || (!workspaces.length && !inAdmin)}
          onChange={event => {
            const id = event.target.value;
            if (id === 'platform' && profile?.isAdmin) navigate('/admin');
            else if (workspaces.some(workspace => workspace.workspaceId === id)) navigate(`/workspaces/${id}`);
          }}
        >
          {!selected && <option value="" disabled>{loading ? 'Loading workspaces…' : 'Choose a workspace'}</option>}
          {workspaces.map(workspace => <option key={workspace.workspaceId} value={workspace.workspaceId}>
            {workspace.name}{workspace.kind === 'studio' ? ' · Studio' : ''}
          </option>)}
          {profile?.isAdmin && <option value="platform">Platform Admin</option>}
        </Select>
      </FormControl>
      {error && <Text fontSize="xs" mt={2} role="status">
        Workspaces are unavailable. <Button variant="link" size="xs" onClick={reload}>Retry</Button>
      </Text>}
    </Box>
  );
};
